
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const LoginPage = lazy(() => import('../pages/login/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const StyleSelectionPage = lazy(() => import('../pages/style-selection/page'));
const ActivatePage = lazy(() => import('../pages/activate/page'));
const PetCardPage = lazy(() => import('../pages/pet-card/page'));
const PetCardStylePage = lazy(() => import('../pages/pet-card-style/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <LoginPage />
  },
  {
    path: '/profile',
    element: <ProfilePage />
  },
  {
    path: '/style-selection',
    element: <StyleSelectionPage />
  },
  {
    path: '/s/:code',
    element: <ActivatePage />
  },
  {
    path: '/pet-card',
    element: <PetCardPage />
  },
  {
    path: '/pet-card-style',
    element: <PetCardStylePage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
